module.exports = __webpack_public_path__ + "static/img/6.7f670ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news29/6.png
// module id = LFTM
// module chunks = 1